import { cn } from '@/lib/utils.ts'

export interface QualityScoreBarProps {
  score: number
  className?: string
}

function scoreColor(score: number): string {
  if (score >= 100) return 'bg-green-500'
  if (score >= 75) return 'bg-yellow-400'
  if (score >= 50) return 'bg-amber-500'
  return 'bg-red-500'
}

export function QualityScoreBar({ score, className }: QualityScoreBarProps) {
  const clamped = Math.max(0, Math.min(100, score))
  return (
    <div className={cn('flex items-center gap-2 min-w-[120px]', className)}>
      <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-all', scoreColor(clamped))}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className="text-small text-gray-600 tabular-nums w-10 text-right">
        {clamped} %
      </span>
    </div>
  )
}
